import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HeaderTemplateData } from '../dialog-data.interface';

@Component({
    selector: 'dialog4-template',
    templateUrl: 'dialog4-template.html',
    styleUrls: ['dialog4-template.scss']
})
export class Dialog4Template implements OnInit {
    header:HeaderTemplateData;
    constructor(
        public dialogRef: MatDialogRef<Dialog4Template>,
        @Inject(MAT_DIALOG_DATA) private data: HeaderTemplateData,

    ) {
        if(data){
            this.header = data;
        }
    }

    ngOnInit() {
      
    }

}
